import styled from 'styled-components'
import { WHITE } from '../../utils/colors'
import { MD } from '../../utils/screenSizes'

export const Container = styled.div`
  display: flex;
  align-items: center;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  color: ${WHITE};

  @media (max-width: ${MD}) {
    font-size: 13px;
  }

  .content {
    flex: 1;
    margin-top: 5px;
    margin-right: 28px;
    .name {
      font-weight: 600;
    }

    .logout {
      color: ${WHITE};
      display: block;
      text-decoration: none;
      margin-top: 10px;
    }
  }

  .avatar {
    border-radius: 50%;
    overflow: hidden;
    background-color: ${WHITE};
    width: 77px;
    height: 77px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    @media (max-width: ${MD}) {
        width: 45px;
        height: 45px;
    }
  }
`
